<template>
  <RBtn type="text" size="small" @click="onClick">
    <Grid gaf="column" align-items="center" gap="var(--r-space-xs)">
      FINALIZE

      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.46742 12.1224L10.3774 9.21239L7.46742 6.30239C7.17492 6.00989 7.17492 5.53739 7.46742 5.24489C7.75992 4.95239 8.23242 4.95239 8.52492 5.24489L11.9674 8.68739C12.2599 8.97989 12.2599 9.45239 11.9674 9.74489L8.52492 13.1874C8.23242 13.4799 7.75992 13.4799 7.46742 13.1874C7.18242 12.8949 7.17492 12.4149 7.46742 12.1224Z"
          fill="#00ADB5"
        />
      </svg>
    </Grid>
  </RBtn>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  methods: {
    onClick() {
      const parent = this.params.context.invoiceTableCmp

      parent.finalize(this.params.data)
    }
  }
})
</script>
